<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div *ngIf="this.versions != null">

    <div class="container-auth" *ngIf="isLoggedIn$ | async">
        <div class="search-term">
            <input name="search" matInput [(ngModel)]="term" (keydown.enter)="getVersions()" placeholder="{{fSearch}}" maxlength="255" />
            <button (click)="getVersions()" mat-raised-button color="primary">{{fSearch}}</button>
        </div>
        <div class="versions-container">
            <div *ngFor="let version of versions">
                <h2>{{version.major}}.{{version.minor}}.{{version.revision}}</h2>
                <span type="released-date">{{fRelease}} {{version.created_timestamp | date }}</span>
                <h3>{{version.description}}</h3>
                <div [innerHTML]="version.detail"></div>
            </div>
            <h2 *ngIf="versions.length == 0">{{fNone}}</h2>
        </div>
    </div>

    <div class="container-no-auth" *ngIf="!(isLoggedIn$ | async)">
        <app-logo-card-page [style]="style">
            <div class="search-term">
                <input name="search" matInput [(ngModel)]="term" (keydown.enter)="getVersions()" placeholder="{{fSearch}}" maxlength="255" />
                <button (click)="getVersions()" mat-raised-button color="primary">{{fSearch}}</button>
            </div>
            <div class="versions-container">
                <h1>{{fNotes}}</h1>
                <div *ngFor="let version of versions">
                    <h2>{{version.major}}.{{version.minor}}.{{version.revision}}</h2>
                    <span type="released-date">{{fRelease}} {{version.created_timestamp | date }}</span>
                    <h3>{{version.description}}</h3>
                    <div [innerHTML]="version.detail"></div>
                </div>
                <h2 *ngIf="versions.length === 0">{{fNone}}</h2>
            </div>
        </app-logo-card-page>
    </div>

</div>
